import { render, staticRenderFns } from "./addForm copy.vue?vue&type=template&id=72c50b6e&scoped=true&"
import script from "./addForm copy.vue?vue&type=script&lang=js&"
export * from "./addForm copy.vue?vue&type=script&lang=js&"
import style0 from "./addForm copy.vue?vue&type=style&index=0&id=72c50b6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c50b6e",
  null
  
)

export default component.exports